import styled from 'styled-components'

const Button = styled.button`
  background: rgb(36,36,36);
  border-radius: 15px;
  padding: 10px 20px;
  font-family: Rubik, sans-serif;
  font-weight: 700;
  color: white;
  border: none;
  font-size: 20px;
`

export default Button
